export const brandCategories = [
    "Balenciaga",
    "Bottega Veneta",
    "CHANEL",
    "DIOR",
    "Dolce & Gabbana",
    "GUCCI",
    "Louis Vuitton",
    "MIU MIU",
    "PRADA",
    "Thom Browne",
];

export const categories = {
    men: {
        clothes: ["outer", "top", "bottom", "homewear", "innerwear"],
        bags: [
            "crossbag",
            "waistbag",
            "totebag",
            "backpack",
            "shoulderbag",
            "laptopbag",
        ],
        shoes: [
            "sneakers",
            "loafers",
            "formal",
            "boots",
            "sandals",
            "accessories",
        ],
        accessories: ["wallets", "hats", "watches", "eyewear", "ties", "belts"],
    },
    women: {
        clothes: [
            "top",
            "pants",
            "dresses",
            "skirts",
            "jumpsuits",
            "outer",
            "innerwear",
        ],
        bags: [
            "shoulderbag",
            "crossbag",
            "totebag",
            "ecobags",
            "backpack",
            "clutch",
            "pouch",
        ],
        shoes: ["flats", "boots", "pumps", "sandals", "slippers", "sneakers"],
        accessories: [
            "jewelry",
            "hats",
            "watches",
            "wallets",
            "eyewear",
            "belts",
        ],
    },
};
